import i from "./ghl-ui.es358.js";
import t from "./ghl-ui.es681.js";
function f(r) {
  return t(r) && i(r);
}
export {
  f as default
};
